import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';

const EditableTextAreaCell = ({ id, field, value, label, saveEditedField, darkMode, focusIndex, categoryUuid, workId }) => {
    // Определяем цвета в зависимости от поля
    const getFieldColors = (field) => {
        switch (field) {
            case 'comment':
            case 'name_by_acts':
                return {
                    color: darkMode ? '#2196f3' : '#1565c0',
                };
            case 'closing':
                return {
                    color: darkMode ? '#ff8f00' : '#e65100',
                };
            case 'cost':
                return {
                    color: darkMode ? '#e91e63' : '#c2185b',
                };
            default:
                return {
                    color: darkMode ? '#1976d2' : '#1976d2',
                };
        }
    };

    const fieldColors = getFieldColors(field);
    const [localValue, setLocalValue] = useState(value);

    const handleTextChange = (e, index) => {
        if (Array.isArray(localValue)) {
            const newArray = [...localValue];
            newArray[index] = e.target.value;

            setLocalValue(newArray);
        } else {
            setLocalValue(e.target.value);
        }
    };

    const handleBlur = () => {
        console.log(value, localValue)
        saveEditedField({
            rowId: id,
            field: field,
            value: localValue,
            isValueChanged: value !== localValue,
            shouldExitEditMode: false, // Не выходим из режима редактирования при blur
            categoryUuid: categoryUuid,
            workId: workId,
        });
    };

    return (
        <Box data-editing-cell="true" sx={{ display: 'grid', gridAutoRows: '1fr', flex: 1, alignItems: 'center', gap: 0.5, height: '100%' }}>
            {(Array.isArray(localValue) ? localValue : [localValue]).map((value, index) => (
                <TextField
                    multiline
                    rows={10}
                    size="small"
                    value={value || ''}
                    onChange={(e) => handleTextChange(e, index)}
                    onBlur={handleBlur}
                    autoFocus
                    data-editing="true"
                    placeholder={field === 'comment' || field === 'name_by_acts' ? 'Markdown поддерживается: **жирный**, *курсив*, # заголовок' : ''}
                    sx={{
                        minWidth: '100px',
                        '& .MuiOutlinedInput-input': {
                            p: '0px',
                            cursor: 'text',
                            color: darkMode ? '#ffffff' : '#333',
                            fontSize: '0.8rem',
                            lineHeight: '1.1',
                        },
                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: fieldColors.color,
                            borderWidth: '2px',
                        },
                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
                        },
                        '& .MuiInputLabel-root': {
                            color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                            fontSize: '0.8rem',
                            '&.Mui-focused': {
                                color: fieldColors.color,
                            }
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                            borderRadius: '4px',
                        },
                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                        '& .MuiInputBase-root': {
                            fontWeight: 500,
                            fontSize: '0.8rem',
                            borderRadius: '4px',
                            minWidth: '120px',
                            width: '120px'
                        },
                        '& .MuiInputBase-input': {
                            borderRadius: '4px',
                        },
                    }}
                />
            ))}
            {Array.isArray(localValue) && localValue.length > 1 &&
                <Box></Box>
            }
        </Box>
    );
};

export default EditableTextAreaCell;

